import { render, staticRenderFns } from "./producer_create_cider_page.vue?vue&type=template&id=6865fe85&scoped=true"
import script from "./producer_create_cider_page.vue?vue&type=script&lang=js"
export * from "./producer_create_cider_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6865fe85",
  null
  
)

export default component.exports